import { Flex } from "@aws-amplify/ui-react";
import General from '../utils/GeneralUtils';
import './GradeSpan.scss';

export default function GradeSpan(input: any) {
  const { row } = input;

  const theme = input?.theme === 'dark' ? 'dark' : 'light'

  const grades = {
    'gNurseryOfrd': 'NS',
    'grade_pk': 'PK',
    'grade_kg': 'KG',
    'grade_1': '1',
    'grade_2': '2',
    'grade_3': '3',
    'grade_4': '4',
    'grade_5': '5',
    'grade_6': '6',
    'grade_7': '7',
    'grade_8': '8',
    'grade_9': '9',
    'grade_10': '10',
    'grade_11': '11',
    'grade_12': '12',
    'grade_13': '13'
  };
  const gradesHumanReadable: any = {
    'NS': 'Nursery',
    'PK': 'Pre-K',
    'KG': 'Kindergarten',
    '1': '1st grade',
    '2': '2nd grade',
    '3': '3rd grade',
    '4': '4th grade',
    '5': '5th grade',
    '6': '6th grade',
    '7': '7th grade',
    '8': '8th grade',
    '9': '9th grade',
    '10': '10th grade',
    '11': '11th grade',
    '12': '12th grade',
    '13': '13th grade'
  }
  const entries: [string, string][] = Object.entries(grades);
  return <div>
    <Flex className={`grade-span theme-${theme}`} alignItems={"center"} gap={1}>
      {
        entries
          .map(grade =>
            <div
              key={General.getRandomString(5)}
              data-tooltip-id="main-tooltip"
              data-tooltip-content={`${gradesHumanReadable[grade[1]]} offered`}
              data-tooltip-hidden={!row[grade[0]]}
              className={ row[grade[0]] ? 'grade grade-offered' : 'grade' }
            ></div>
          )
      }
    </Flex>
  </div>
}
